module.exports = __webpack_public_path__ + "static/media/icon_minMax.3966c15e.svg";